/**
 * 岗位胜任力 1-5 分对应的等级名（PR-6「胜任力模板表头」）。
 *
 * 单一真源，供：
 *   - 后端导入/导出模板表头（competency-model-import.service.ts）
 *   - 前端领导打分页锚点与评分选项（apps/pc，经 @api-common 引用）
 *
 * 内部存储仍是 anchors['1']…anchors['5']，等级名只用于展示层。
 */
export const COMPETENCY_LEVEL_NAMES: Record<string, string> = {
  '1': '待发展',
  '2': '基础',
  '3': '胜任线',
  '4': '优秀',
  '5': '卓越',
};

/** 导入/导出表头格式：「1级-待发展」。 */
export function competencyLevelHeader(score: number): string {
  return `${score}级-${COMPETENCY_LEVEL_NAMES[String(score)] ?? ''}`;
}

/** 打分页锚点/选项格式：「1级·待发展」。 */
export function competencyLevelLabel(score: number): string {
  return `${score}级·${COMPETENCY_LEVEL_NAMES[String(score)] ?? ''}`;
}
